

































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetTems } from "@/request/common";
@Component({})
export default class Name extends mixins(listMixin) {
  @Prop()
  private IfShow: any;
  @Watch("IfShow", { immediate: true })
  private IfShowChange() {
    this.filters.sort_field = "更新时间";
    this.filters["题目类型"] = [];
    this.ifVisible = this.IfShow;
    if (this.IfShow) {
      this.selectedMessages = [];
      this.getList();
    }
  }
  private ifVisible: any = false;
  private data: any = [];
  private typeOption: any = ["单选", "多选", "判断", "填空"];
  private options: any = ["舌", "面", "目", "掌", "脉", "耳穴", "四诊"];
  private cancel() {
    this.$emit("cancel");
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      search: this.filters.search,
      类别: this.filters["分类"],
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
      应用模式: "考试模式",
    };
    if (this.filters["分类"] == "四诊") {
      params["题目类型"] = this.filters["题目类型"];
    }
    localStorage.setItem("shixunFilter", JSON.stringify(this.filters));
    GetTems(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((element: any) => {
          const inc = this.selectedMessages.findIndex((i: any) => {
            return (
              i["question_template_id"] === element["question_template_id"]
            );
          });
          if (inc !== -1) {
            element["selected"] = true;
          } else {
            element["selected"] = false;
          }
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private sure() {
    if (this.selectedMessages.length == 0) {
      this.$message.warning("请选择题目");
      return;
    }
    this.$emit("change", this.selectedMessages);
  }
}
